export default __webpack_public_path__ + "static/media/1128040325511020.967e7251.jpg";